<template>
  <div>
    <div>

      <div class="mt-3" style="line-height: 2.5;">
        <strong>Elementos enviados a laboratorio: </strong>
          <span v-for="(r, i) in protesisProp.elementos " :key="i" > {{r}}, </span> <br/>
          <span> <strong>Colorimetro: </strong> {{ protesisProp.nombreColorimetro }} </span> <br/>
      </div>

      <div class="d-flex">
        <div v-for="(d, ind) in protesisProp.dienteColores" :key="d.idTratamientoProgramado" style="margin-left: 2px">
        <b-card class="h-100 w-100 ml-2 cardDientes">
          <div class="d-flex justify-content-start" style="position: relative;  margin-left: -6px; width: 120px; color: #2981C4; margin-top: -11px;">
            <div class="circleSelect"  ><span> {{ind +1 }} </span></div>
            <div class="mt-1 ml-3" style="display: flex;" >
              <div>
                <em class="dienteProtesis" style="width: 1.2em;"/>
              </div>
              <span class="ml-2">
                    OD {{d.diente}}
                  </span>
            </div>
          </div>
          <div class="mt-2 d-flex" >
            <div style="width: 50px">
              <b-img
                  :src="require('../../../assets/laboratorio/dienteProtesis2.png')"
                  alt="diente"
              ></b-img>
            </div>
            <div style="color: #2981C4; margin-left: 15px; " >
               <span>   {{d.tercioInsisalOclusal}} </span> <br/>
               <span> {{d.tercioMedio}}  </span><br/>
               <span> {{d.tercioCervical}}  </span>
            </div>
          </div>
        </b-card>
      </div>
      </div>

      <div class="mt-4" style="line-height: 2;" v-if="protesisProp.aplicaRestauraciones">
        <strong>Restauraciones implantosoportadas </strong> <br/>
        <strong >Marca:</strong> <span>{{protesisProp.nombreMarca}}</span> <br/>
        <strong>Diámetro:</strong> <span>{{protesisProp.nombreDiametro}}</span> <br/>
        <strong>Conexión:</strong> <span>{{protesisProp.nombreConexion}}</span> <br/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DetalleProtesis",
  props: {
    protesisProp: Object
  },
  data: () => ({

  })
}
</script>
<style scoped>
.cardDientes {
  border-color: #A6CBD1;
}
.textSize {
  font-size: 0.7em;
}

.circleSelect {
  border: 1px solid;
  border-radius: 50%;
  display: inline-block;
  padding: 8px;
  width: 21px;
  height: 21px;
  line-height: 4px;
  background-color: #2981C4;
  color: white;
  font-size: 14px;
}
</style>